import {
  faCaretDown,
  faCaretUp,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromGranularToRaw,
  removeFormulaFromSection,
} from "../../actions/formulaAction";

const SuntenRemoveFormulaPopup = ({
  closePopup,
  isRawType,
  days,
  setPrepMethod,
  setRawGram,
  formulas,
  setDays,
  setTimePerDay,
}) => {
  const dispatch = useDispatch();
  const [scoop, setScoop] = useState(0);
  const [time, setTime] = useState(0);

  return (
    <Modal show={true} id="prescription-popup" size="lg">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">
                    we will remove all the patented formulas as they are only
                    available in granular form
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button
              className="btn-orange"
              onClick={() => {
                setRawGram();
                formulas
                  .filter((x) => x.isSuntenFormula)
                  .forEach((x) =>
                    dispatch(removeFormulaFromSection(x.formulaId))
                  );
                dispatch(changeFormulaTypeFromGranularToRaw(!isRawType, days));
                setPrepMethod && setPrepMethod(null);
                setTimePerDay && setTimePerDay(0);
                setDays(1);
                closePopup();
              }}
            >
              Proceed
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default SuntenRemoveFormulaPopup;
